import request from "@/utils/request";

// 查询后台首页信息
export function getHomeData() {
  return request({
    url: "/admin/blog",
    method: "get"
  });
}

// 解锁屏幕
export function unlockScreen(password) {
  return request({
    url: '/admin/unlockscreen',
    method: 'post',
    data: { password }
  })
}

// 查询博客信息（关于我和公告）
export function getBlogInfo() {
  return request({
    url: "/admin/blog/info",
    method: "get"
  });
}

// 保存公告
export function saveNotice(data) {
  return request({
    url: "/admin/blog/notice",
    method: "post",
    data: data
  });
}

// 保存关于我
export function saveAbout(data) {
  return request({
    url: "/admin/blog/about",
    method: "post",
    data: data
  });
}
